import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';
// import en from 'vuetify/lib/locale/en'
import 'vuetify/src/styles/main.sass';

Vue.use(Vuetify);

const THEME_STORAGE_KEY = 'vuetify-theme-dark';

const LIGHT_SECONDARY = '#88abc2';
const DARK_SECONDARY = '#50c2f7';

export const lightTheme = {
  primary: '#00496f',
  secondary: LIGHT_SECONDARY,
  primaryLight: LIGHT_SECONDARY,
  tertiary: '#d0e0eb',
  quaternary: '#ebf7f8',
  accent: '#8c9eff',

  // Estados
  success: '#16A34A',
  warning: '#F59E0B',
  error: '#b71c1c',
  info: '#0284C7',

  // Botones semánticos
  accept: '#16A34A',
  cancel: '#64748B',
  confirm: '#2563EB',
  neutral: '#475569',

  background: '#f4f7fb',
  surface: '#ffffff',
  mapOverlay: '#537582',
};

export const darkTheme = {
  primary: '#64b5f6',
  secondary: DARK_SECONDARY,
  primaryLight: DARK_SECONDARY,
  tertiary: '#28b5f6',
  quaternary: '#02a6f2',
  accent: '#ffb74d',

  // Estados
  success: '#22C55E',
  warning: '#FBBF24',
  error: '#F87171',
  info: '#38BDF8',

  // Botones semánticos
  accept: '#22C55E',
  cancel: '#94A3B8',
  confirm: '#60A5FA',
  neutral: '#CBD5E1',

  background: '#121212',
  surface: '#1e1e1e',
  mapOverlay: '#37474f',
};

const isDarkThemeEnabled = () => localStorage.getItem(THEME_STORAGE_KEY) === 'true';

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es',
  },
  breakpoint: {
    mobileBreakpoint: 'xs',
  },
  theme: {
    dark: isDarkThemeEnabled(),
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
});
